var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "70%",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c(
            "el-row",
            [
              _c("span", { staticClass: "dialog-title-text" }, [
                _vm._v("调价设置"),
              ]),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "商城售价以结算价或市场价、建议售价为基准浮动",
                    placement: "right",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-alert__icon el-icon-warning",
                    staticStyle: { color: "#f56c6c" },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "setFormRule",
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            model: _vm.setFormRule,
            "label-position": "left",
            "label-width": "100px",
            inline: true,
            size: "small",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    label: "调价规则名称",
                    prop: "rule_name",
                    rules: {
                      required: true,
                      message: "调价规则不能为空",
                      trigger: "change",
                    },
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "157px" },
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.setFormRule.rule_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.setFormRule, "rule_name", $$v)
                      },
                      expression: "setFormRule.rule_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    label: "调价基数",
                    prop: "money_type",
                    rules: [
                      {
                        required: true,
                        trigger: "change",
                        message: "请选择调价基数",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.setFormRule.money_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.setFormRule, "money_type", $$v)
                        },
                        expression: "setFormRule.money_type",
                      },
                    },
                    _vm._l(_vm.moneyTypes, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.id, attrs: { label: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    label: "调价方式",
                    prop: "adjust_type",
                    rules: [
                      {
                        required: true,
                        trigger: "change",
                        message: "请选择调价方式",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.setFormRule.adjust_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.setFormRule, "adjust_type", $$v)
                        },
                        expression: "setFormRule.adjust_type",
                      },
                    },
                    [
                      _c("el-checkbox", { key: "1", attrs: { label: "1" } }, [
                        _vm._v("按比例浮动"),
                      ]),
                      _c("el-checkbox", { key: "2", attrs: { label: "2" } }, [
                        _vm._v("按金额浮动"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.setFormRule.adjust_type.length
            ? _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _vm.priceType == "all" || _vm.priceType == "ratio"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "by_ratio_adjust",
                            rules: [
                              { required: true, message: "请输入调价比例" },
                              {
                                pattern: /^(-|\+)?\d+(\.\d{1,2})?$/,
                                message: "请填写数字格式，仅限两位小数",
                              },
                              {
                                validator: function (rule, value, callback) {
                                  if (!value) {
                                    return callback()
                                  }
                                  // 计算最终折扣：100% + 调价比例（负数表示降价）
                                  var finalDiscount = 100 + parseFloat(value)
                                  // 允许的最小折扣是配置的预警值
                                  var minDiscount = this$1.warning_restrictions
                                  if (finalDiscount < minDiscount) {
                                    return callback(
                                      "当前折扣不可低于" +
                                        minDiscount +
                                        "，请重新输入！"
                                    )
                                  }
                                  callback()
                                },
                                trigger: ["input", "change", "blur"],
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c(
                                "span",
                                {
                                  style: {
                                    color:
                                      _vm.setFormRule.by_ratio_adjust &&
                                      100 +
                                        Number(
                                          _vm.setFormRule.by_ratio_adjust
                                        ) <
                                        _vm.warning_restrictions
                                        ? "red"
                                        : "",
                                  },
                                },
                                [_vm._v("调价比例(%)")]
                              ),
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "157px" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.setFormRule.by_ratio_adjust,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.setFormRule,
                                  "by_ratio_adjust",
                                  $$v
                                )
                              },
                              expression: "setFormRule.by_ratio_adjust",
                            },
                          }),
                          _c("span", { staticClass: "title" }, [
                            _vm._v("加价一个点,请输入1；"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.priceType == "all" || _vm.priceType == "money"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "调整金额",
                            prop: "by_money_adjust",
                            rules: [
                              { required: true, message: "请输入调整金额" },
                              ,
                              {
                                pattern: /^((-|\+)?\d+)\.?(\d{0,2})$/,
                                message: "请填写数字格式，仅限两位小数",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "157px" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.setFormRule.by_money_adjust,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.setFormRule,
                                  "by_money_adjust",
                                  $$v
                                )
                              },
                              expression: "setFormRule.by_money_adjust",
                            },
                          }),
                          _c("span", { staticClass: "title" }, [
                            _vm._v("售价=标准售价+调整金额"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("el-form-item", { staticStyle: { flex: "1" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.moneyTypes.length
            ? _c("div", [
                _vm._v(
                  " 商城售价= " +
                    _vm._s(
                      _vm.moneyTypes.find(function (o) {
                        return o.id == _vm.setFormRule.money_type
                      }).name
                    ) +
                    " *(1+调整比例) 例:" +
                    _vm._s(
                      _vm.moneyTypes.find(function (o) {
                        return o.id == _vm.setFormRule.money_type
                      }).name
                    ) +
                    "=100,调整比例=1%,商城售价=100(1+1%)=101.00 "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm.ruleType != 4
        ? _c(
            "div",
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "客户范围", name: "custom" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "商品范围", name: "cinema" },
                  }),
                ],
                1
              ),
              _vm.activeName == "custom"
                ? _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c("span", [_vm._v("选择客户范围：")]),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { margin: "5px 0", "font-size": "14px" },
                          model: {
                            value: _vm.customRadio,
                            callback: function ($$v) {
                              _vm.customRadio = $$v
                            },
                            expression: "customRadio",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("指定客户"),
                          ]),
                          _c("el-radio", { attrs: { label: -1 } }, [
                            _vm._v("全部客户"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeName == "custom" && _vm.customRadio == 1
                ? _c(
                    "el-form",
                    {
                      staticClass: "home__search",
                      attrs: { data: _vm.customForm, inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户ID" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.customForm.id,
                              callback: function ($$v) {
                                _vm.$set(_vm.customForm, "id", $$v)
                              },
                              expression: "customForm.id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户名称" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.customForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.customForm, "name", $$v)
                              },
                              expression: "customForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.searchCustom("custom")
                                },
                              },
                            },
                            [_vm._v("查 询")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeName == "custom" && _vm.customRadio == 1
                ? _c("div", { staticClass: "custom-style" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        _c("h3", { staticStyle: { margin: "5px 0" } }, [
                          _vm._v("待选客户"),
                        ]),
                        _c(
                          "el-table",
                          {
                            ref: "multipleTable",
                            staticStyle: {
                              height: "400px",
                              "overflow-y": "auto",
                            },
                            attrs: {
                              border: "",
                              stripe: true,
                              "header-cell-style": {
                                background: "#f1f1f1",
                                color: "#333333",
                              },
                              align: "center",
                              data: _vm.customList,
                            },
                            on: {
                              "selection-change": function (res) {
                                return _vm.handleSelectionCustom(res, "custom")
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                selectable: _vm.selectableCustom,
                                width: "35",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "客户ID",
                                width: "80px",
                                prop: "id",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "客户名称",
                                prop: "company_name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "center" },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { margin: "0" },
                            attrs: {
                              type: "primary",
                              icon: "el-icon-arrow-right",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.batchAddCustom("custom")
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "margin-left": "-5px",
                                },
                              },
                              [_vm._v("添加")]
                            ),
                          ]
                        ),
                        _vm.checkedDelCustom.length
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { margin: "0" },
                                attrs: {
                                  type: "warning",
                                  icon: "el-icon-arrow-left",
                                  circle: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.batchDel("custom")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "10px",
                                      "margin-left": "-5px",
                                    },
                                  },
                                  [_vm._v("移除")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("h3", [_vm._v("已选客户")]),
                        _c(
                          "el-table",
                          {
                            staticStyle: {
                              height: "400px",
                              "overflow-y": "auto",
                            },
                            attrs: {
                              border: "",
                              stripe: true,
                              "header-cell-style": {
                                background: "#f1f1f1",
                                color: "#333333",
                              },
                              align: "center",
                              data: _vm.checkedCustomList,
                            },
                            on: {
                              "selection-change": function (res) {
                                return _vm.handleCheckedDelCustom(res, "custom")
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "35" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "客户ID",
                                width: "80px",
                                prop: "id",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "客户名称",
                                prop: "company_name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.activeName == "custom" && _vm.customRadio == 1
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "margin-top": "10px",
                        "padding-bottom": "10px",
                      },
                    },
                    [
                      _c("el-pagination", {
                        key: "custom",
                        attrs: {
                          background: "",
                          "page-sizes": [20, 50, 200],
                          layout: "total, prev, pager, next, sizes",
                          "page-size": 20,
                          total: _vm.pages.totalCount,
                        },
                        on: {
                          "size-change": function (res) {
                            return _vm.sizeChange(res, "custom")
                          },
                          "current-change": function (res) {
                            return _vm.onChange(res, "custom")
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeName == "cinema" && !this.selected_standard_ids.length
                ? _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c("span", [_vm._v("选择商品范围：")]),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { margin: "5px 0", "font-size": "14px" },
                          model: {
                            value: _vm.goodsRadio,
                            callback: function ($$v) {
                              _vm.goodsRadio = $$v
                            },
                            expression: "goodsRadio",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: -1 } }, [
                            _vm._v("全部商品"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitAdjustRule } },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }